import React, { useContext } from "react";
import { Star } from "lucide-react";
import "./TeamFeedback.css";

import alextyson from "../../asset/alextyson.jpg";
import WalterWhiteImg from "../../asset/Walterwhite.jpg";
import Jaro from "../../asset/Jaro.jpg";
import SaulGoodmanImg from "../../asset/SaulGoodman.jpg";
import JessePinkmanImg from "../../asset/JessePinkman.jpg";
import SkylerWhiteImg from "../../asset/SkylerWhite.jpg";
import { CanvasContext } from "../../contexts/CanvasContext";

const TeamFeedback = () => {
  const { isDarkTheme } = useContext(CanvasContext);
  const testimonials = [
    {
      name: "Alex Tyson",
      rating: 5,
      image: alextyson,
      text: "NexGen Sites revolutionized my web development process. The drag-and-drop interface is intuitive, and I can create stunning websites without writing a single line of code. It's a game-changer for designers like me who want to bring their visions to life quickly.",
    },
    {
      name: "Walter White",
      rating: 5,
      image: WalterWhiteImg,
      text: "As a chemistry teacher turned web enthusiast, I appreciate the precision of NexGen Sites. The automatic code generation is flawless, and it's fascinating to see how my visual designs translate into clean, efficient code. It's like cooking up the perfect website!",
    },
    {
      name: "Jaro",
      rating: 4,
      image: Jaro,
      text: "NexGen Sites' multi-page support is impressive. I've been able to create complex websites with ease, managing different sections and layouts effortlessly. While there's a slight learning curve, the results are worth it. It's transformed how I approach web projects.",
    },
    {
      name: "Saul Goodman",
      rating: 5,
      image: SaulGoodmanImg,
      text: "Better call NexGen Sites for all your web development needs! As a lawyer, I need a professional online presence, and this platform delivers. The multi-project feature allows me to manage websites for different practice areas seamlessly. It's simply the best!",
    },
    {
      name: "Jesse Pinkman",
      rating: 4,
      image: JessePinkmanImg,
      text: "Yo, NexGen Sites is tight! I've been using it to build websites for my friends' businesses, and it's been a breeze. The drag-and-drop feature is mad easy to use, and the sites look professional AF. It's like, science, b***h!",
    },
    {
      name: "Skyler White",
      rating: 5,
      image: SkylerWhiteImg,
      text: "NexGen Sites has been a lifesaver for our family business. The ability to create and manage multiple projects has allowed us to expand our online presence efficiently. The platform's user-friendly interface made it easy for me to take control of our web development needs.",
    },
  ];

  return (
    <div
      className={`team-feedback__container ${isDarkTheme ? "dark-theme" : ""}`}
    >
      <section className="team-feedback__testimonials">
        <h2
          className={`team-feedback__section-title ${
            isDarkTheme ? "dark-theme" : ""
          }`}
        >
          Customer Testimonials
        </h2>
        <p
          className={`team-feedback__section-description ${
            isDarkTheme ? "dark-theme" : ""
          }`}
        >
          Hear what our users have to say about NexGen Sites, the revolutionary
          web builder platform that's changing the game in web development.
        </p>
        <div className="team-feedback__testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className={`team-feedback__testimonial-card ${
                isDarkTheme ? "dark-theme" : ""
              }`}
            >
              <img
                src={testimonial.image}
                alt={testimonial.name}
                className="team-feedback__testimonial-image"
              />
              <h3
                className={`team-feedback__testimonial-name ${
                  isDarkTheme ? "dark-theme" : ""
                }`}
              >
                {testimonial.name}
              </h3>
              <div className="team-feedback__testimonial-rating">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    className={
                      i < testimonial.rating
                        ? "team-feedback__star-filled"
                        : "team-feedback__star-empty"
                    }
                  />
                ))}
              </div>
              <p
                className={`team-feedback__testimonial-text ${
                  isDarkTheme ? "dark-theme" : ""
                }`}
              >
                {testimonial.text}
              </p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default TeamFeedback;
